import { useRef, useCallback } from "react";

export const useGetLatest = (value) => {
  const ref = useRef();
  ref.current = value;
  return useCallback(() => ref.current, [ref]);
};
